<template>
  <div>
    <v-layout align-center justify-center>
      <v-flex
        text-xs-center
        :class="[nota.descripcion_nota != 'Diciembre'? 'xs2' : 'xs10']"
      >{{nota.descripcion_nota}}</v-flex>
    </v-layout>
    <v-layout class="border_nota" align-center justify-center text-xs-center>
      <v-flex xs2>{{nota.nota == '0' || nota.nota == '00' || nota.nota == 'AUS'? 'AUS' : nota.nota}}</v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: ["nota"],
  mounted: function() {
    //console.log("mounted -> itemNota !", this.nota);
  },
  methods: {}
};
</script>

<style scoped>
</style>